<template>
    <div class="commdityWrap" id="commdityWrap">
        <h2 class="title clearfix"><i class="hot fl"></i>
            <span class="titleName colorRed fl">热门商品</span>
            <!-- <span class="fr link">中药</span>
            <span class="fr link">中药</span>
            <span class="fr link">中药</span>
            <span class="fr link">中药</span> -->
        </h2>
        <!-- <div class="swiper-container" id="hotListSwiper">
            <div class="swiper-wrapper">
                <div class="swiper-slide" style="width: 230px" v-for="(item,index) in list" :key="index">
                    <router-link :to="'/goodDetail/'+item.goods_id" target="_blank" class="hotGoods">
                        <img :src="item.original_img | thumbnailUrl" alt="" />
                        <div class="colorBlue f14 goods_name">{{item.common_name}}<span v-if="item.goods_name!==''">({{ item.goods_name }})</span></div>
                        <div class="price colorRed f13">￥ {{ item.market_price }}</div>
                        <div>规格:{{ item.goods_spec }}</div>
                        <div class="company">产商:{{ item.manufacturer_name }}</div>
                        <div>采购价:<span class="colorRed" v-text="item.wholesale_price==='登录可见'?'登录可见':'￥'+ item.wholesale_price"></span></div>
                    </router-link>
                </div>
            </div>
        </div> -->
        <div class="marquee" style="height: 260px; max-width: 1200px">
            <vue-marquee style="height:290px;max-width: 1200px" direction="left" v-if="isShow">
                <vue-marquee-slide v-for="(item,index) in list" :key="index">
                    <div style="width: 230px; height: 230px;position: relative">
                        <router-link :to="'/goodDetail/'+item.goods_id" target="_blank" class="hotGoods">
                            <img :src="item.original_img | thumbnailUrl" alt="" />
                            <div class="colorBlue f14 goods_name">{{item.common_name}}<span v-if="item.goods_name!==''">({{ item.goods_name }})</span></div>
                            <!--<div class="price colorRed f13">￥ {{ item.market_price }}</div>-->
                            <div>规格:{{ item.goods_spec }}</div>
                            <div class="company">产商:{{ item.manufacturer_name }}</div>
                            <!--<div>采购价:<span class="colorRed" v-text="item.wholesale_price==='登录可见'?'登录可见':'￥'+ item.wholesale_price"></span></div>-->
                        </router-link>
                    </div>
                </vue-marquee-slide>
            </vue-marquee>
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import {GoodsService } from '../../service/goods.service';
import { Marquee, Slide } from "vue-marquee-component"
export default {
    props: ['prop'],
    components: {
        [Marquee.name]: Marquee,
        [Slide.name]: Slide
    },
    data() {
        return {
            startIndex: 0,
            swiper: null,
            isShow: false,
            list: [],
        }
    },
    methods: {
        toDetail(data) {
            this.$router.push(`/goodDetail/${data.goods_id}`);
        },
        mounteSwiper() {
            this.swiper = new Swiper ('#hotListSwiper', {
                loop: true,
                speed:6000,
                freeMode:true,
                autoplay: {
                    delay: 0,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.swiper-pagination',
                    type : 'fraction'
                },
                slidesPerView : 4,
            })
        }
    },
    async mounted() {
        const { hotGoods } = await GoodsService.homeData();
        this.list = hotGoods;
        this.mounteSwiper();
        this.isShow = true;
    },
}
</script>
<style lang="scss" scoped>
    .title{
        height: 55px;
        line-height: 55px;
        margin-top: 5px;
        font-size: 15px;
        font-weight: bold;
    }
    .hot{
        background: url('../../assets/images/icon/hotIcon.png') left center no-repeat;
        width: 30px;
        height: 55px;
        line-height: 55px;
        display: inline-block;
        background-size: 20px;
        vertical-align: text-top;
        animation: jump 1s infinite;
    }
    .title .link{
        margin-right: 15px;
        margin-top: 30px;
        line-height: 15px;
        height: 15px;
        cursor: pointer;
    }
    .title .link:hover{
        text-decoration: underline;
        color: #e4221c
    }
    @keyframes jump{
        0%{}
        50%{transform: translateY(-10px)}
        100%{}
    }
    .swiper-container, .marquee {
        width: 1200px;
        height: 230px;
        margin: 0px auto 20px;
        padding-bottom: 32px;
        padding-top: 9px;
        border: 1px solid #e3e2e1;
    }
    .swiper-slide{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        text-align: center;
        cursor: pointer;
    }
    .swiper-slide img{
        width: 170px;
        height: 170px;
        margin: 0 auto;
    }
    .swiper-pagination{
       bottom: 0px;
    }
    .swiper-container-free-mode > .swiper-wrapper {
  -webkit-transition-timing-function: linear;    /*之前是ease-out*/
  -moz-transition-timing-function: linear;
  -ms-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
  margin: 0 auto;
}
.hotGoods {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    width: 230px;
    img {
        height: 160px;
        width: 160px;
    }
}
</style>